module.exports = __webpack_public_path__ + "img/banner_h501.2cc2567d.webp";